<div class="skills-edit">
  <h2 class="skills-edit__title">{{ title | translate }}</h2>

  <div class="skills-edit__row">
    <label class="skills-edit__label" for="skills-edit-search">{{ 'label.YourSkills' | translate }}</label>

    <div class="skills-edit__field">
      <div class="skill-search">
        <input
          id="skills-edit-search"
          class="skill-search__input"
          [class.skill-search__input--with-add]="canAddCustomSkill"
          type="text"
          autocomplete="off"
          [formControl]="skillInput"
          [placeholder]="placeholder | translate"
          (keydown.enter)="addCustomSkill()"
        />

        @if (canAddCustomSkill) {
          <button
            type="button"
            class="skill-search__add"
            [title]="'label.SkillsAddNew' | translate"
            [attr.aria-label]="'label.SkillsAddNew' | translate"
            (click)="addCustomSkill()"
          >
            <svg-icon src="/assets/icons/plus-small.svg" class="skill-search__add-icon"></svg-icon>
          </button>
        }

        @if (skillInput.value && (suggestions?.queryResultItems?.length || suggestions?.suggestedItems?.length)) {
          <div class="suggestions">
            @for (item of suggestions.queryResultItems; track item.skillId) {
              <div class="suggestions__item" (click)="selectSkill(item)">
                @if (getMatchSplit(item.name); as parts) {
                  <span>{{ parts.pre }}</span><span class="suggestions__match">{{ parts.match }}</span><span>{{ parts.post }}</span>
                }
              </div>
            }
            @for (item of suggestions.suggestedItems; track item.skillId) {
              <div class="suggestions__item" (click)="selectSkill(item)">
                @if (getMatchSplit(item.name); as parts) {
                  <span>{{ parts.pre }}</span><span class="suggestions__match">{{ parts.match }}</span><span>{{ parts.post }}</span>
                }
              </div>
            }
          </div>
        }
      </div>

      <div class="skills-edit__hint">
        <svg-icon src="/assets/icons/drag-dots.svg" class="skills-edit__hint-icon"></svg-icon>
        {{ 'label.SkillsReorderHint' | translate }}
      </div>

      <div class="chosen-skills">
        @if (draftSkills?.length) {
          <hrra-skills
            [skills]="draftSkills"
            [userType]="userType"
            (onRemoveSkill)="removeSkill($event)"
            (onReorderSkills)="reorderSkills($event)"
          ></hrra-skills>
        }
      </div>
    </div>
  </div>

  <div class="actions">
    <button type="button" class="actions__button actions__button--save" [disabled]="saveDisabled" (click)="save()">
      {{ 'label.Save' | translate }}
    </button>
    <button type="button" class="actions__button actions__button--cancel" [mat-dialog-close]="true">
      {{ 'label.Cancel' | translate }}
    </button>
  </div>
</div>
